import { render } from "./QC2.vue?vue&type=template&id=385f6368"
import script from "./QC2.vue?vue&type=script&lang=js"
export * from "./QC2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "385f6368"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('385f6368', __exports__)) {
    console.log('reload')
    api.reload('385f6368', __exports__)
  }
  
  module.hot.accept("./QC2.vue?vue&type=template&id=385f6368", () => {
    console.log('re-render')
    api.rerender('385f6368', render)
  })

}


export default __exports__